import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { copyBoard } from '../state/actions.tsx';
import { getBoard, isCopyInProgress, getOnCancel } from '../state/selectors.tsx';
import type { State } from '../state/types.tsx';
import CopyBoardsModal from './view.tsx';

const mapStateToProps = (state: State) => ({
	board: getBoard(state),
	copyInProgress: isCopyInProgress(state),
	onCancel: getOnCancel(state),
});

export default connect(mapStateToProps, {
	onCopy: copyBoard,
})(CopyBoardsModal);
